import { TabV2Props } from 'flow/components/pbx/v2/misc/TabsV2';
import useAppContext from 'flow/hooks/useAppContext';
import ScrollablePillTabs from 'flow/components/ui-components/ScrollablePillTabs';

export type DetailPageTabKey = 'LOG' | 'CONTACT' | 'RELATED' | 'TICKET_DETAILS';

interface Props {
    selectedTab: DetailPageTabKey;
    onSelectTab: (tab: DetailPageTabKey) => void;
    hasTicket: boolean;
    ticketAccessDenied?: boolean;
    tabsHidden?: DetailPageTabKey[];
}

const TabsCallRecordDetail = ({
    selectedTab,
    onSelectTab,
    hasTicket,
    ticketAccessDenied,
    tabsHidden,
}: Props) => {
    const { i18next } = useAppContext();

    const tabs: TabV2Props[] = [
        { key: 'LOG', label: i18next.t('call.log') },
        { key: 'CONTACT', label: i18next.t('cti.wrapper.type.label.contact') },
        { key: 'RELATED', label: i18next.t('tickets.related.title') },
        // ...(hasTicket
        //     ? [
        //           {
        //               key: 'TICKET_DETAILS' as const,
        //               label: i18next.t('ticket.details'),
        //               disabled: ticketAccessDenied,
        //               tooltip: ticketAccessDenied
        //                   ? i18next.t(
        //                         'Only members of this ticket can view its details',
        //                     )
        //                   : undefined,
        //           },
        //       ]
        //     : []),
    ].filter((tab) => !tabsHidden?.includes(tab.key as DetailPageTabKey));

    const handleClick = (tab: TabV2Props) => {
        onSelectTab(tab.key as DetailPageTabKey);
    };

    return (
        <div className="flex h-20 items-center py-2">
            <ScrollablePillTabs
                selectedKey={selectedTab}
                tabs={tabs}
                onClick={handleClick}
            />
        </div>
    );
};

export default TabsCallRecordDetail;
